import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  TextField,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";

export default class AddProduct extends Component {
  state = {
    product_name: "",
    product_category: "",
    description: "",
    product_image: null,

    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  /* =========================
     HANDLERS
  ========================= */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /* =========================
     SUBMIT
  ========================= */
  handleSubmit = async (e) => {
    e.preventDefault();

    if (init() !== "success") {
      return this.setState({ redirect: true });
    }

    const { product_name, product_category, product_image } = this.state;

    if (!product_name || !product_category || !product_image) {
      return this.setState({
        notification: true,
        message: "Product name, category and image are required",
      });
    }

    this.setState({ loading: true });

    const formData = new FormData();
    formData.append("product_name", product_name);
    formData.append("product_category", product_category);
    formData.append("description", this.state.description);
    formData.append("product_image", product_image);

    try {
      await axios.post(Constants.postUrls.createProduct, formData);

      this.setState({
        notification: true,
        message: "Product added successfully",
        loading: false,
      });

      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong",
        loading: false,
      });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    if (this.state.redirect) return <Navigate to="/products" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
            >
              <MDTypography color="white">
                Add Product
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* PRODUCT NAME */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      required
                      label="Product Name"
                      name="product_name"
                      onChange={this.handleChange}
                      style={{marginTop: "20px"}}
                    />
                  </Grid>

                  {/* PRODUCT CATEGORY */}
                 <Grid item xs={6}>
  <InputLabel sx={{ mb: 1 }}>
    Product Category
  </InputLabel>

  <Select
    fullWidth
    required
    name="product_category"
    value={this.state.product_category}
    onChange={this.handleChange}
    displayEmpty
    sx={{ height: "45px" }}
  >
    <MenuItem value="">
      Select Category
    </MenuItem>

    <MenuItem value="Single Seeds for Birds">
      Single Seeds for Birds
    </MenuItem>

    <MenuItem value="Bird Feed Mixes">
      Bird Feed Mixes
    </MenuItem>

    <MenuItem value="HummingBird Food">
      HummingBird Food
    </MenuItem>

    <MenuItem value="Other Products">
      Other Products
    </MenuItem>
  </Select>
</Grid>


                  {/* PRODUCT IMAGE */}
                  <Grid item xs={12}>
                    <TextField
                      type="file"
                      label="Product Image"
                      InputLabelProps={{ shrink: true }}
                      required
                      onChange={(e) =>
                        this.setState({
                          product_image: e.target.files[0],
                        })
                      }
                    />
                  </Grid>

                  {/* DESCRIPTION */}
                <Grid item xs={12}>
  <MDTypography mb={1}>
    Product Description (Optional)
  </MDTypography>

  <SunEditor
    setContents={this.state.description}
    onChange={(content) =>
      this.setState({ description: content })
    }
    setOptions={{
      height: 200,
      buttonList: [
        ["undo", "redo"],
        ["bold", "underline", "italic"],
        ["fontColor", "hiliteColor"],
        ["align", "list"],
        ["link"],
        ["removeFormat"],
      ],
    }}
  />
</Grid>


                </Grid>

                <MDBox mt={3}>
                  <MDButton
                    type="submit"
                    color="info"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Saving..." : "Create Product"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              open={this.state.notification}
              content={this.state.message}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
